var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIdea2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6671 25.3333C50.6671 14.9333 42.1604 6.51994 31.7271 6.66994C21.7504 6.81328 13.5571 14.9399 13.3404 24.9166C13.2071 31.0766 16.0604 36.5766 20.5504 40.0699C21.8704 41.0966 22.6671 42.6533 22.6671 44.3233V45.3333H41.3338V44.3233C41.3338 42.6933 42.0638 41.1333 43.3571 40.1399C47.8004 36.7299 50.6671 31.3666 50.6671 25.3299V25.3333Z",
    fill: "#FFC82A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3346 45.3335H22.668V52.0002C22.668 54.9468 25.0546 57.3335 28.0013 57.3335H36.0013C38.948 57.3335 41.3346 54.9468 41.3346 52.0002V45.3335Z",
    fill: "#FFAD24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3307 19.9998C34.3307 18.7112 33.2861 17.6665 31.9974 17.6665C30.7087 17.6665 29.6641 18.7112 29.6641 19.9998V26.6665C29.6641 27.9552 30.7087 28.9998 31.9974 28.9998C33.2861 28.9998 34.3307 27.9552 34.3307 26.6665V19.9998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9974 35.6667C33.2861 35.6667 34.3307 34.622 34.3307 33.3333C34.3307 32.0447 33.2861 31 31.9974 31C30.7087 31 29.6641 32.0447 29.6641 33.3333C29.6641 34.622 30.7087 35.6667 31.9974 35.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdea2);
export default __webpack_public_path__ + "static/media/icon_idea_2.e6ee7454.svg";
export { ForwardRef as ReactComponent };